module.exports = __webpack_public_path__ + "static/media/PM37.93f4204a.png";